export default "__VITE_ASSET__Dv69DVZc__"